import type {PromotionalBannerPayload} from '@github-ui/in-product-targeting'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {useLocation} from '@github-ui/react-router'

import type {CopilotImmersivePayload} from '../routes/payloads'

export function usePromotionalBanner(): PromotionalBannerPayload | undefined {
  const {copilotPromotionalBanner} = useAppPayload<CopilotImmersivePayload>()
  const {pathname} = useLocation()

  return pathname === '/copilot' ? copilotPromotionalBanner : undefined
}
